import { AccessorsMutatorsDecorator, Model } from '../../helpers';
import { TranslatableModel } from './translatable-model';
import moment from "moment";

export class InternalMessage extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [];
    }

    get creator() {
        return  this.user.name + ' ' + moment(this.created_at).format('DD/MM/YYYY hh:mm A');
    }

    static get ACTIVE() {

        return 1;
    }

    static get NOT_ACTIVE() {

        return 0;
    }

    static get TYPE_BEFORE() {

        return 1;
    }

    static get TYPE_AFTER() {

        return 0;
    }

    static get TYPES() {

        return {
            [this.TYPE_BEFORE]: 'BEFORE',
            [this.TYPE_AFTER]: 'AFTER',
        };
    }

    static get FORMATTED_STATUSES() {

        return {
            [this.ACTIVE]: 'ACTIVE',
            [this.NOT_ACTIVE]: 'INACTIVE',
        };
    }

    formatStatus() {

        return this.constructor.FORMATTED_STATUSES[this.status];
    }

    formatTypes() {

        return this.constructor.TYPES[this.type];
    }

    getStatusLabel() {

        switch (this.status) {

            case this.constructor.ACTIVE:

                return 'ACTIVE';

            case this.constructor.NOT_ACTIVE:

                return 'INACTIVE';
        }
    }

    static get validationModel() {

        return {
            discount_value: {
                messages: {
                    required: 'SELECT_DISCOUNT_REQUIRED'
                }
            },
            period_length: {
                messages: {
                    required: 'LENGTH_EXT_PERIOD_REQUIRED'
                }
            },
        };
    }
}

AccessorsMutatorsDecorator('id', 'user_id', 'type', 'status', 'message', 'message_ar', 'number_days', 'created_at', 'updated_at', 'owners_count', 'user', 'users')(InternalMessage);



// WEBPACK FOOTER //
// ./src/pms-api/models/internal-message.model.js